import { createSlice } from "@reduxjs/toolkit";

const equiposSlice = createSlice({
  name: "equipos",
  initialState: {
    currentEquipos: null,
    isFetching: false,
    error: false,
  },
  reducers: {
    equiposStart: (state) => {
      state.isFetching = true;
    },
    equiposSuccess: (state, action) => {
      state.isFetching = false;
      state.currentEquipos = action.payload;
    },
    equiposFailure: (state) => {
      state.isFetching = false;
      state.error = true;
    },
    createEquipoStart: (state) => {
        state.isFetching = true;
    },
    createEquipoSuccess: (state, action) => {
        state.isFetching = false;
        state.currentEquipos = action.payload
        state.errorCreate = false;
    },
    createEquipoFailure: (state) => {
        state.isFetching = false;
        state.errorCreate = true;
    },
    logoutInfoEquipos: (state) => {
      state.currentEquipos = null;
      state.isFetching = false;
      state.error = false;
      state.errorCreate = false;
    },
  },
});

export const {
  equiposStart,
  equiposSuccess,
  equiposFailure,
  createEquipoStart, 
  createEquipoSuccess, 
  createEquipoFailure,
  logoutInfoEquipos
} = equiposSlice.actions;
export default equiposSlice.reducer;
